"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MissingDumpTicket = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.MissingDumpTicket = typebox_1.Type.Object({
    first_name: typebox_1.Type.String(),
    days_since_pickup: typebox_1.Type.Number(),
    service_location: typebox_1.Type.String(),
    pickup_date: typebox_1.Type.String(),
    order_number: typebox_1.Type.Number(),
    wayste_order_id: typebox_1.Type.String(),
});
//# sourceMappingURL=missing-dump-ticket.js.map